import { i18n } from '@/mixins/localization'
import { useMixStore } from '@/stores/MixStore'
import { useModalStore } from '@/stores/ModalStore'
import type { IngredientParams } from '@/types/ingredient'
import MixValidator from '@/validators/mixValidator'

export class MixService {
  private mixStore = useMixStore()
  private modalStore = useModalStore()
  private t: (slug: string) => string
  private validator: MixValidator

  constructor(private kind: string) {
    this.t = (slug) => i18n.global.t(slug)
    this.validator = new MixValidator(this.mixStore.getMix(kind)!)
  }

  addIngredient(params: IngredientParams) {
    const { ingredient, quantity } = params
    const existingItem = this.mixStore.getMix(this.kind)?.items.find((i) => {
      return i.ingredient.id === ingredient.id
    })
    if (existingItem) {
      this.mixStore.increaseQuantity({ kind: this.kind, ingredient, quantity })
      if (!this.validator.isValid()) {
        const [error] = this.validator.getErrors()
        const message = this.t(`general.mix.validation.${error.key}`)
        this.mixStore.decreaseQuantity({ kind: this.kind, ingredient, quantity })
        this.modalStore.openModal({
          id: 'modal-alert',
          title: message,
        })
      }
    } else {
      const mix = this.mixStore.getMix(this.kind)
      if (mix) {
        if (ingredient.isBase && mix.shouldHasBase && mix.hasBase) {
          this.mixStore.changeBase({ kind: this.kind, ingredient })
          if (this.validator.isValid()) {
            this.modalStore.openModal({
              id: 'modal-alert',
              title: this.t('general.mix.validation.base_was_changed'),
            })
          }
        } else {
          this.mixStore.addItem({ kind: this.kind, ingredient, quantity })
        }
      }

      if (!this.validator.isValid()) {
        const [error] = this.validator.getErrors()
        const message = this.t(`general.mix.validation.${error.key}`)
        this.mixStore.removeItem({ kind: this.kind, ingredient })
        this.modalStore.openModal({
          id: 'modal-alert',
          title: message,
        })
      }
    }

    this.mixStore.getMix(this.kind)?.calculateNutrients()
  }

  removeIngredient(params: IngredientParams) {
    const { ingredient } = params
    const existingItem = this.mixStore.getMix(this.kind)?.items.find((i) => {
      return i.ingredient.id === ingredient.id
    })
    if (existingItem && existingItem.amount > 1) {
      this.mixStore.decreaseQuantity({ kind: this.kind, ingredient, quantity: 1 })
      if (!this.validator.isValid()) {
        this.mixStore.increaseQuantity({ kind: this.kind, ingredient, quantity: 1 })
        alert(this.validator.getErrors())
      }
    } else {
      this.mixStore.removeItem({ kind: this.kind, ingredient })
      if (!this.validator.isValid()) {
        this.mixStore.addItem({ kind: this.kind, ingredient, quantity: 1 })
        alert(this.validator.getErrors())
      }
    }

    this.mixStore.getMix(this.kind)?.calculateNutrients()
  }
}
